import type { FaireProductEntity } from "../../entity_types/product";

export const p_m4zse6v9q8: FaireProductEntity = {
  token: "p_m4zse6v9q8",
  type: "product",
  name: "Dog Party Gift Bag - Small",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2acd93533bca17636487b4d949a3f82953f60275342e40f87ba5aaf6c62a0985.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d178e819be4fd5f340701f5e6a85d29ea5758be52553d719853cff48221425cc.jpeg",
    "https://cdn.faire.com/fastly/bdc5b2769e8026f6a7c419d506c6f3f7d0ffc81e34aa57c90dd189b76d8ea47d.webp",
    "https://cdn.faire.com/fastly/b3a6ffe78c4cdce83a02ed14da1ed46d5371b7947d3fda5aaf04692d70134c88.webp",
  ],
  priceDollars: 2.5,
  description:
    "Yes, this gift bag is awesome. It's cute and fun and illustrated and might even outshine whatever you put inside! But it's that little die-cut tag that might just be the cutest thing we have ever seen. The Medium size is perfect for one of those really nice gifty candles. Or some of our other favorite gifts... assorted E. Frances products, 4-5 bags of chocolate chips, or 84 packs of gum. The Small size perfectly fits 2 to 5 boxes of Little Notes®. Or a chipmunk. The Large size fits 8 cans of new tennis balls or... you tell us what you get in there and give us some great ideas!",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:21.092Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
